<template>
  <section class="bg-black">
    <div class="block xlh:block smh:hidden">
      <div class="years-heading pt-0 sm:pt-0" data-aos="fade-up" data-aos-offset="2800">
        <p class="wehave text-2xl">WE HAVE</p>
        <p class="years w-full text-7xl">20+ YEARS</p>

        <div>
          <p class="p-years text-base pb-8">
            of knowledge and experience in perfecting our craftsmanship in
            Japanese Cuisine
          </p>
        </div>
      </div>

      <div class="bg-black pb-44 pt-8" id="years-img" data-aos="fade-up" data-aos-offset="2800">
        <img :src="require('../assets/home/years-2.jpg')" class="w-4/5 sm:w-full" alt="" />
      </div>
    </div>

    <div class="hidden xlh:hidden smh:block">
      <div class="years-heading pt-0 sm:pt-0" data-aos="fade-up" data-aos-offset="0">
        <p class="wehave text-2xl">WE HAVE</p>
        <p class="years w-full text-7xl">20+ YEARS</p>

        <div>
          <p class="p-years text-base pb-8">
            of knowledge and experience in perfecting our craftsmanship in
            Japanese Cuisine
          </p>
        </div>
      </div>

      <div class="bg-black pb-44 pt-8" id="years-img" data-aos="fade-up" data-aos-offset="0">
        <img :src="require('../assets/home/years.jpg')" class="w-4/5 sm:w-full" alt="" />
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
#years-img img {
  margin: auto;

}

.years-heading {
  height: auto;
  background: black;
}

.wehave {
  width: 100%;
  height: 50px;
  margin: auto;
  font-family: Times;
  font-style: normal;
  font-weight: normal;

  line-height: 36px;
  /* identical to box height, or 150% */

  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  /* white */

  color: #ffffff;
}

.years {
  height: 70px;
  margin: auto;
  font-family: Times;
  font-style: italic;
  font-weight: normal;
  text-align: center;

  line-height: 70px;
  /* identical to box height, or 73% */

  text-transform: uppercase;

  color: #c7272b;
}

.p-years {
  width: 100%;
  padding: 1%;
  margin: auto;
  font-family: avenirLight;
  font-style: normal;
  font-weight: normal;

  line-height: 20px;
  /* or 125% */

  text-align: center;
  letter-spacing: 0.02em;

  /* white */

  color: #ffffff;
}
</style>